var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFleche(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30.5 30.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#21bbee;stroke-miterlimit:10;stroke-width:0.5px;fill-rule:evenodd;fill:url(#D\xE9grad\xE9_sans_nom_30);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30",
    x1: 0.25,
    y1: 15.25,
    x2: 30.25,
    y2: 15.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21bbee"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "param\\xE9trage_3",
    "data-name": "param\\xE9trage 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.79,9.14c-3.73.23-9.24.76-12.69.81.57-.71,1.9-1.85,2.61-2.69a.8.8,0,0,0,.07-1.15C17.6,4.42,16.44,2.72,15.05,1,14.36.11,13.66,0,12.9.86,11.85,2.13,3.74,10.84.66,14.18a1.59,1.59,0,0,0,0,2.14C3.74,19.66,11.85,28.37,12.9,29.64c.76.91,1.46.75,2.15-.12,1.39-1.74,2.55-3.44,3.73-5.13a.8.8,0,0,0-.07-1.15c-.71-.84-2-2-2.61-2.69,3.45.05,9,.58,12.69.81,1,.05,1.46-3,1.46-6.11S29.76,9.09,28.79,9.14Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleche);
export default __webpack_public_path__ + "static/media/fleche.b55ae37b37b393aabfce3dc1696f3090.svg";
export { ForwardRef as ReactComponent };